import { Plus } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { IProjectUser } from 'projects/types';
import { Color } from 'theme/enums';

import { UpsertUser } from './UpsertUser';

interface IProps {
  projectId: number;
  user?: IProjectUser;
  buttonElement?: ReactElement;
}

export const UpsertUserButton = ({ projectId, user, buttonElement }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const onClose = () => {
    setIsOpen(false);
  };

  const button = useMemo(() => {
    if (buttonElement) {
      return cloneElement(buttonElement, {
        onClick: () => setIsOpen(true),
      });
    }

    return (
      <Button
        text={t('buttonLabelAddProjectUser')}
        color={Color.SUCCESS}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
      />
    );
  }, [buttonElement, t]);

  return (
    <>
      {button}

      <UpsertUser isOpen={isOpen} onClose={onClose} projectId={projectId} user={user} />
    </>
  );
};
